export const groupPostsByLetter = (data) => {
  if (!data) {
    return false;
  }

  let grouped = {};

  data.map((result) => {
    let firstLetter = result.Fund_Name.charAt(0);

    if (typeof grouped[firstLetter] === "undefined") {
      grouped[firstLetter] = [];
    }
    grouped[firstLetter].push(result);
  });

  // create a new object sorted alphabetically
  let sorted = {};
  Object.keys(grouped)
    .sort()
    .forEach((letter) => {
      sorted[letter] = grouped[letter];
    });

  return sorted;
};

export const groupMedicationsByLetter = (data) => {
  if (!data) {
    return false;
  }

  let grouped = {};

  data.map((result) => {
    let firstLetter = result.Name.charAt(0);

    if (typeof grouped[firstLetter] === "undefined") {
      grouped[firstLetter] = [];
    }
    grouped[firstLetter].push(result);
  });

  let keys = Object.keys(grouped).sort();
  let letters = [];
  let numbers = [];

  keys.forEach((key) => {
    if (isNaN(parseInt(key))) {
      letters.push(key);
    } else {
      numbers.push(key);
    }
  });

  const sortedKeys = letters.concat(numbers);

  let sorted = [];
  sortedKeys.forEach((letter) => {
    const obj = {
      letter: letter.toString(),
      items: grouped[letter],
    };

    sorted.push(obj);
  });

  return sorted;
};
